import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datepicker';
import styled from 'styled-components';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Container,
  Row,
  Col,
  CardBody,
  CardHeader,
  Collapse
} from 'reactstrap';
import moment from 'moment';
import DepartmentsSelect from './DepartmentsSelect';
import SpecialtySelect from './SpecialtySelect';
import CitySelector from './CitySelector';
import HospitalSelector from './HospitalSelector';
import BookApptForm from './BookApptForm';
import DoctorSelector from './DoctorSelector';
import SelectProcedure from './SelectProcedure';
import SelectSiteScan from './SelectSiteScan';
import { FaRedo } from 'react-icons/fa';
import SlotList from './SlotList';
import TimingsSelect from './TimingsSelect';
import DoctorChargesTable from './DoctorChargesTable';
import { APP_NAME } from '../constants';

const SpacedContainer = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
`;

const DivTopMargin = styled.div`
  margin-top: 10px;
`;
const FlexEndContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
`;

const QuickBookingModal = props => {
  const { isOpen, toggle } = props;
  const [selectedDate, updateSelectedDate] = useState(moment());
  const [step, updateStep] = useState(0);
  const [searchType, updatesearchType] = useState(0);
  const [selectedCity, updateSelectedCity] = useState();
  const [selectedHospital, updateSelectedHospital] = useState();
  const [selectedDepartment, updateSelectedDepartment] = useState();
  const [selectedSlot, updateSelectedSlot] = useState();
  const [selectedEntityId, updateSelectedEntityId] = useState();
  const [selectedProcedure, updateSelectedProcedure] = useState();
  const [selectedDoctor, updateSelectedDoctor] = useState();
  const [selectedTiming, updateSelectedTiming] = useState();
  const [selectedSpecialty, updateSelectedSpecialty] = useState(null);
  const [selectedScan, updateSelectedScan] = useState();

  const handleOnClose = () => {
    updateSelectedDate(moment());
    updateStep(0);
    updateSelectedCity();
    updateSelectedHospital();
    updateSelectedDepartment();
    updateSelectedSlot();
    updateSelectedProcedure();
    updateSelectedDoctor();
    updatesearchType(0);
    updateSelectedTiming();
  };
  const resetData = () => {
    updateStep(0);
    updateSelectedHospital();
    updateSelectedDepartment();
    updateSelectedSlot();
    updateSelectedProcedure();
    updateSelectedDoctor();
    updateSelectedTiming();
    // updatesearchType(0);
    updateSelectedSpecialty(null);
    updateSelectedScan();
  };
  const handleSearchType = step => {
    if (searchType !== step) {
      resetData();
    }
    updatesearchType(step);
  };
  const handleCitySelection = city => {
    updateSelectedCity(city);
    resetData();
  };
  const handleHospitalSelection = hospital => {
    if (searchType === 1) updateSelectedProcedure();
    else if (searchType === 2) {
      updateSelectedDoctor();
      updateSelectedEntityId();
      updateSelectedSpecialty(null);
    }
    updateSelectedHospital(hospital);
    if (searchType === 3) updateSelectedScan();
  };
  const handleDeptSelection = dept => {
    updateSelectedDepartment(dept);
    updateSelectedSpecialty(null);
  };

  const handleSpecialtySelection = value => {
    updateSelectedSpecialty(value || null);
    updateSelectedDoctor();
    updateSelectedEntityId();
    updateSelectedProcedure();
    updateStep(0);
  };

  const handleTimingSelection = time => {
    updateSelectedTiming(time);
  };
  const onSlotSelection = item => {
    updateSelectedSlot(item);
    updateStep(2);
  };
  const handleDoctorSelection = item => {
    if (searchType === 1) updateSelectedHospital();
    if (searchType === 2) updateSelectedProcedure();
    updateSelectedEntityId(item.value.entityId);
    updateSelectedDoctor(item);
    if (searchType === 3) updateStep(1);
  };

  const handleDoctorsFetched = doctors => {
    if (searchType === 3) {
      if (!doctors || doctors.length === 0) {
        updateSelectedDoctor(null);
        updateSelectedEntityId(null);
        updateSelectedSlot(null);
        updateStep(0);
      }
    }
  };

  const jumpDateBy = days => {
    const startDate = selectedDate;
    let newDate;
    newDate = moment(startDate).add(days, 'days');
    updateSelectedDate(newDate);
  };
  const loadPrevSlots = () => {
    if (selectedDate.isSame(moment(), 'date')) {
      return;
    }
    jumpDateBy(-5);
  };
  const loadNextSlots = () => jumpDateBy(5);

  const showDoctorCharges =
    selectedDoctor && selectedHospital && searchType !== 3;
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      onClosed={handleOnClose}
      keyboard={false}
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>Quick Appointment Booking</ModalHeader>
      <ModalBody>
        <Container>
          <Row style={{ marginBottom: '15px' }}>
            <Col sm={12} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '20px' }}>
                <input
                  type="radio"
                  id="sbd"
                  onClick={() => handleSearchType(1)}
                  checked={searchType === 1}
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />
                <label
                  htmlFor="sbd"
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                >
                  Search by Doctor(Consultation)
                </label>
              </div>

              <div>
                <input
                  type="radio"
                  id="sbh"
                  onClick={() => handleSearchType(2)}
                  checked={searchType === 2}
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />
                <label
                  htmlFor="sbh"
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                >
                  Search by Hospital(Consultation)
                </label>
              </div>

              <div style={{ marginLeft: '20px' }}>
                <input
                  type="radio"
                  id="sbs"
                  onClick={() => handleSearchType(3)}
                  checked={searchType === 3}
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />
                <label
                  htmlFor="sbs"
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                >
                  Book Scan
                </label>
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm={11}>
              {searchType !== 0 && (
                <Row>
                  <Col sm={4}>
                    <SpacedContainer className="row">
                      <Col sm={12}>Date</Col>
                    </SpacedContainer>
                    <Row>
                      <Col sm={12}>
                        <DateTimePicker
                          placeholderText="Select Date"
                          selected={selectedDate}
                          minDate={moment()}
                          dateFormat="DD MMM YYYY"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          onChange={date => updateSelectedDate(moment(date))}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={4}>
                    <SpacedContainer className="row">
                      <Col sm={12}>City</Col>
                    </SpacedContainer>
                    <Row>
                      <Col sm={12}>
                        <CitySelector
                          value={selectedCity}
                          onChange={handleCitySelection}
                          placeholder="City"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
              {selectedCity && searchType === 1 ? (
                <Row>
                  {/* search by doctor */}
                  <Col sm={3}>
                    <SpacedContainer className="row">
                      <Col sm={12}>Doctor</Col>
                    </SpacedContainer>
                    <Row>
                      <Col sm={12}>
                        <DoctorSelector
                          onChange={handleDoctorSelection}
                          value={selectedDoctor ? selectedDoctor : ''}
                          cityId={
                            selectedCity && selectedCity.value
                              ? selectedCity.value
                              : null
                          }
                          dateSelected={
                            selectedDate
                              ? [moment(selectedDate).format('DD - MM - YYYY')]
                              : null
                          }
                          placeholder="Doctor"
                          isInPersonConsultation={true}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {selectedDoctor ? (
                    <Col sm={3}>
                      <SpacedContainer className="row">
                        <Col sm={12}>Hospital</Col>
                      </SpacedContainer>
                      <Row>
                        <Col sm={12}>
                          <HospitalSelector
                            cityId={
                              selectedCity && selectedCity.value
                                ? selectedCity.value
                                : null
                            }
                            value={selectedHospital}
                            onChange={handleHospitalSelection}
                            placeholder="Hospital"
                            arrayValues={selectedDoctor}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : null}
                  {/* {selectedDoctor && selectedHospital ? (
                    <Col sm={3}>
                      <SpacedContainer className="row">
                        <Col sm={12}>Department</Col>
                      </SpacedContainer>
                      <Row>
                        <Col sm={12}>
                          <DepartmentsSelect
                            onChange={handleDeptSelection}
                            value={selectedDepartment ? selectedDepartment : ''}
                            placeholder="Department"
                            value={
                              selectedDoctor.value &&
                              selectedDoctor.value.department
                                ? selectedDoctor.value.department
                                : ''
                            }
                            showOptions={false}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : null} */}
                  {selectedDoctor && selectedHospital ? (
                    <Col sm={3}>
                      <SpacedContainer className="row">
                        <Col sm={12}>Procedure</Col>
                      </SpacedContainer>
                      <Row>
                        <Col sm={12}>
                          <SelectProcedure
                            hospitalId={
                              selectedHospital ? selectedHospital.value : ''
                            }
                            entityId={selectedEntityId}
                            selectedProcedure={selectedProcedure}
                            onProcedureSelect={selectedProcedure => {
                              updateSelectedProcedure(selectedProcedure);
                              updateStep(1);
                            }}
                            isInPersonConsultation={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : null}
                </Row>
              ) : selectedCity && searchType === 2 ? (
                <Row>
                  {/* search by hospital */}
                  <Col sm={3}>
                    <SpacedContainer className="row">
                      <Col sm={12}>Hospital</Col>
                    </SpacedContainer>
                    <Row>
                      <Col sm={12}>
                        <HospitalSelector
                          cityId={
                            selectedCity && selectedCity.value
                              ? selectedCity.value
                              : null
                          }
                          value={selectedHospital}
                          onChange={handleHospitalSelection}
                          placeholder="Hospital"
                        />
                      </Col>
                    </Row>
                  </Col>
                  {selectedHospital ? (
                    <>
                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Department</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <DepartmentsSelect
                              onChange={handleDeptSelection}
                              value={
                                selectedDepartment ? selectedDepartment : ''
                              }
                              placeholder="Department"
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Specialty</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <SpecialtySelect
                              value={
                                selectedSpecialty ? selectedSpecialty : null
                              }
                              onChange={handleSpecialtySelection}
                              placeholder="Specialty"
                            />
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Timings</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <TimingsSelect
                              onChange={handleTimingSelection}
                              value={selectedTiming ? selectedTiming : ''}
                              placeholder="Timings"
                              selectedDate={selectedDate}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Doctor</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <DoctorSelector
                              onChange={handleDoctorSelection}
                              value={selectedDoctor ? selectedDoctor : ''}
                              hospitalIds={
                                selectedHospital && selectedHospital.value
                                  ? [selectedHospital.value]
                                  : null
                              }
                              departmentIds={
                                selectedDepartment ? [selectedDepartment] : null
                              }
                              specialty={
                                selectedSpecialty ? selectedSpecialty : null
                              }
                              cityId={
                                selectedCity && selectedCity.value
                                  ? selectedCity.value
                                  : null
                              }
                              timings={selectedTiming ? [selectedTiming] : null}
                              dateSelected={
                                selectedDate
                                  ? [
                                      moment(selectedDate).format(
                                        'DD - MM - YYYY'
                                      )
                                    ]
                                  : null
                              }
                              placeholder="Doctor"
                              isInPersonConsultation={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </>
                  ) : null}
                  {selectedHospital && selectedDoctor ? (
                    <Col sm={3}>
                      <SpacedContainer className="row">
                        <Col sm={12}>Procedure</Col>
                      </SpacedContainer>
                      <Row>
                        <Col sm={12}>
                          <SelectProcedure
                            hospitalId={
                              selectedHospital ? selectedHospital.value : ''
                            }
                            entityId={selectedEntityId}
                            selectedProcedure={selectedProcedure}
                            onProcedureSelect={selectedProcedure => {
                              updateSelectedProcedure(selectedProcedure);
                              updateStep(1);
                            }}
                            isInPersonConsultation={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : null}
                </Row>
              ) : selectedCity && searchType === 3 ? (
                <Row>
                  <Col sm={3}>
                    <SpacedContainer className="row">
                      <Col sm={12}>Hospital</Col>
                    </SpacedContainer>
                    <Row>
                      <Col sm={12}>
                        <HospitalSelector
                          cityId={
                            selectedCity && selectedCity.value
                              ? selectedCity.value
                              : null
                          }
                          value={selectedHospital}
                          onChange={handleHospitalSelection}
                          placeholder="Hospital"
                        />
                      </Col>
                    </Row>
                  </Col>
                  {selectedHospital ? (
                    <Col sm={5}>
                      <SpacedContainer className="row">
                        <Col sm={12}>Scan</Col>
                      </SpacedContainer>
                      <Row>
                        <Col sm={12}>
                          <SelectSiteScan
                            hosId={selectedHospital.siteCode}
                            isHavingProcedure={true}
                            selectedscanName={selectedScan}
                            placeholder="Search for and select scan items"
                            onscanNameSelect={scanObj => {
                              if (scanObj) {
                                updateSelectedScan(scanObj);
                                updateSelectedProcedure(scanObj.LtProcedure);
                                updateSelectedDoctor(null);
                                updateSelectedTiming(null);
                                updateStep(0);
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ) : null}
                  {selectedHospital && selectedScan ? (
                    <>
                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Timings</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <TimingsSelect
                              onChange={handleTimingSelection}
                              value={selectedTiming ? selectedTiming : ''}
                              placeholder="Timings"
                              selectedDate={selectedDate}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={3}>
                        <SpacedContainer className="row">
                          <Col sm={12}>Doctor</Col>
                        </SpacedContainer>
                        <Row>
                          <Col sm={12}>
                            <DoctorSelector
                              onChange={handleDoctorSelection}
                              value={selectedDoctor ? selectedDoctor : ''}
                              hospitalIds={
                                selectedHospital && selectedHospital.value
                                  ? [selectedHospital.value]
                                  : null
                              }
                              cityId={
                                selectedCity && selectedCity.value
                                  ? selectedCity.value
                                  : null
                              }
                              procedures={
                                selectedScan && selectedScan.LtProcedure
                                  ? [selectedScan.LtProcedure]
                                  : null
                              }
                              timings={selectedTiming ? [selectedTiming] : null}
                              dateSelected={
                                selectedDate
                                  ? [
                                      moment(selectedDate).format(
                                        'DD - MM - YYYY'
                                      )
                                    ]
                                  : null
                              }
                              placeholder="Doctor"
                              onDoctorsFetched={handleDoctorsFetched}
                              showWalkIn={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        sm={3}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div
                          style={{
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                            padding: '6px 12px',
                            marginTop: '25px',
                            backgroundColor: '#f8f9fa'
                          }}
                        >
                          Scan Charge: ₹ {selectedScan.rate || 0}
                        </div>
                      </Col>
                    </>
                  ) : null}
                </Row>
              ) : null}
            </Col>

            {(searchType === 1 || searchType === 2 || searchType === 3) && (
              <FlexEndContainer sm={1} className="col">
                <FaRedo onClick={resetData} style={{ cursor: 'pointer' }} />
              </FlexEndContainer>
            )}
          </Row>
          {showDoctorCharges && (
            <Row>
              <Col>
                <DivTopMargin className="card">
                  <DoctorChargesTable
                    hospitalId={selectedHospital.value}
                    doctorId={Number(selectedDoctor.value.lifetrenzId)}
                  />
                </DivTopMargin>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <DivTopMargin className="card">
                <CardHeader onClick={() => updateStep(1)}>
                  {'Select Slots'}
                </CardHeader>
                <Collapse isOpen={step === 1}>
                  <CardBody>
                    {searchType === 1 ? (
                      !selectedEntityId ? (
                        <span>Please Select Doctor</span>
                      ) : !selectedHospital ? (
                        <span>Please Select Hospital</span>
                      ) : !selectedProcedure ? (
                        <span>Please Select Procedure</span>
                      ) : (
                        <SlotList
                          startDate={selectedDate}
                          entityId={selectedEntityId}
                          onSlotSelect={onSlotSelection}
                          procedureName={selectedProcedure}
                          hospitalId={
                            selectedHospital && selectedHospital.value
                          }
                          onPrevClick={loadPrevSlots}
                          onNextClick={loadNextSlots}
                        />
                      )
                    ) : searchType === 2 ? (
                      !selectedHospital ? (
                        <span>Please Select Hospital</span>
                      ) : !selectedEntityId ? (
                        <span>Please Select Doctor</span>
                      ) : !selectedProcedure ? (
                        <span>Please Select Procedure</span>
                      ) : (
                        <SlotList
                          startDate={selectedDate}
                          entityId={selectedEntityId}
                          onSlotSelect={onSlotSelection}
                          procedureName={selectedProcedure}
                          hospitalId={
                            selectedHospital && selectedHospital.value
                          }
                          onPrevClick={loadPrevSlots}
                          onNextClick={loadNextSlots}
                        />
                      )
                    ) : searchType === 3 ? (
                      !selectedHospital ? (
                        <span>Please Select Hospital</span>
                      ) : !selectedScan ? (
                        <span>Please Select Scan</span>
                      ) : !selectedEntityId ? (
                        <span>Please Select Doctor</span>
                      ) : (
                        <SlotList
                          startDate={selectedDate}
                          entityId={selectedEntityId}
                          onSlotSelect={onSlotSelection}
                          procedureName={selectedProcedure}
                          hospitalId={
                            selectedHospital && selectedHospital.value
                          }
                          onPrevClick={loadPrevSlots}
                          onNextClick={loadNextSlots}
                        />
                      )
                    ) : null}
                  </CardBody>
                </Collapse>
              </DivTopMargin>
            </Col>
          </Row>
          {selectedProcedure !== 'Video Consultation' ? (
            <Row>
              <Col>
                <DivTopMargin className="card">
                  <CardHeader>{'Enter Patient Details'}</CardHeader>
                  <Collapse isOpen={step === 2}>
                    <CardBody>
                      <BookApptForm
                        key={`booking-form-${searchType}-${(selectedHospital &&
                          selectedHospital.value) ||
                          ''}-${(selectedDoctor &&
                          selectedDoctor.value &&
                          selectedDoctor.value.lifetrenzId) ||
                          ''}-${(selectedSlot && selectedSlot.id) || ''}`}
                        hospitalId={
                          selectedHospital ? selectedHospital.value : undefined
                        }
                        selectedSlot={selectedSlot}
                        procedureName={selectedProcedure}
                        doctorId={
                          selectedDoctor && selectedDoctor.value
                            ? selectedDoctor.value.lifetrenzId
                            : undefined
                        }
                        doctorName={
                          selectedDoctor ? selectedDoctor.label : undefined
                        }
                        hospitalName={
                          selectedHospital ? selectedHospital.label : undefined
                        }
                        scanName={
                          selectedScan ? selectedScan.scanName : undefined
                        }
                        mode="quickbook"
                        isScanBooking={searchType === 3}
                      />
                    </CardBody>
                  </Collapse>
                </DivTopMargin>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col className="error text-left mt-2 font-weight-bold">
                {`Note: If you are booking a Video Consultation, please ask the customer to book it on ${APP_NAME} app.`}
              </Col>
            </Row>
          )}
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          CLOSE
        </Button>
      </ModalFooter>
    </Modal>
  );
};

QuickBookingModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func
};

export default QuickBookingModal;
